/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentCategory
 */
export interface TournamentCategory {
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    gender?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCategory
     */
    birthDateMin?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCategory
     */
    birthDateMax?: Date;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    periods?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    periodTime?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    minPlayers?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    maxPlayers?: number;
}

/**
 * Check if a given object implements the TournamentCategory interface.
 */
export function instanceOfTournamentCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TournamentCategoryFromJSON(json: any): TournamentCategory {
    return TournamentCategoryFromJSONTyped(json, false);
}

export function TournamentCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tournamentId': !exists(json, 'tournamentId') ? undefined : json['tournamentId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'birthDateMin': !exists(json, 'birthDateMin') ? undefined : (new Date(json['birthDateMin'])),
        'birthDateMax': !exists(json, 'birthDateMax') ? undefined : (new Date(json['birthDateMax'])),
        'maxTeams': !exists(json, 'maxTeams') ? undefined : json['maxTeams'],
        'periods': !exists(json, 'periods') ? undefined : json['periods'],
        'periodTime': !exists(json, 'periodTime') ? undefined : json['periodTime'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'minPlayers': !exists(json, 'minPlayers') ? undefined : json['minPlayers'],
        'maxPlayers': !exists(json, 'maxPlayers') ? undefined : json['maxPlayers'],
    };
}

export function TournamentCategoryToJSON(value?: TournamentCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tournamentId': value.tournamentId,
        'name': value.name,
        'gender': value.gender,
        'birthDateMin': value.birthDateMin === undefined ? undefined : (value.birthDateMin.toISOString().substring(0,10)),
        'birthDateMax': value.birthDateMax === undefined ? undefined : (value.birthDateMax.toISOString().substring(0,10)),
        'maxTeams': value.maxTeams,
        'periods': value.periods,
        'periodTime': value.periodTime,
        'description': value.description,
        'minPlayers': value.minPlayers,
        'maxPlayers': value.maxPlayers,
    };
}

